import Multiselect from './Multiselect';

export default Multiselect;
